export default "__VITE_ASSET__BMtLWHMT__"